import { render, staticRenderFns } from "./LegacyDocumentList.vue?vue&type=template&id=fdf043ba&scoped=true"
import script from "./LegacyDocumentList.vue?vue&type=script&lang=ts"
export * from "./LegacyDocumentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf043ba",
  null
  
)

export default component.exports